import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Countries } from 'src/app/_global/countries';
import { CustomersService } from 'src/app/_services/settings/customers.service';

@Component({
  selector: 'add-customer',
  templateUrl: './add-customer.component.html',
  styleUrls: ['./add-customer.component.scss']
})
export class AddCustomerComponent implements OnInit {
  loading: boolean = false;
  customerForm: UntypedFormGroup;
  
  constructor(private fb: UntypedFormBuilder,
    public countries: Countries,
    private customersService: CustomersService,
    private toastr: ToastrService,
    public modal: NgbActiveModal) {}

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.customerForm = this.fb.group({
      id: [null],
      name: ['', Validators.required],
      recipientName: [''],
      email: [null, { validators: [Validators.email, Validators.required] }],
      address1: ['', Validators.required],
      address2: [''],
      city: ['', Validators.required],
      district: [''],
      county: [''],
      state: [''],
      postalCode: [''],
      countryCode: ['', Validators.required],
      phoneNumber: ['']
    });
  }

  save() {
    if (this.customerForm.invalid) {
      let controls = this.customerForm.controls;
      Object.keys(controls).forEach(controlName => controls[controlName].markAsTouched());
      return;
    }
    this.loading = true;
    this.customersService.create(this.customerForm.value).subscribe(() => {
      this.toastr.success(`Customer ${this.customerForm.value.name} added successfully`);
      this.modal.close();
    }, err => this.loading = false);
  }
}